import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-container',
  templateUrl: './layout-container.component.html',
  styleUrls: ['./layout-container.component.scss'],
  standalone: false,
})
export class LayoutContainerComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
